import LandingPageShell from "@/components/landing-page/layout/LandingPageShell";
import Pricing from "@/components/landing-page/pricing/Pricing";
import { DEFAULT_CATALOG_MODULE_COUNTS } from "@/lib/data/catalog-module-counts";

export default function PricingPage() {
  return (
    <LandingPageShell>
      <Pricing moduleCounts={DEFAULT_CATALOG_MODULE_COUNTS} />
    </LandingPageShell>
  );
}
